// D14: every logged set carries a client_id, and the server keys retries on
// it — resend the same id and nothing is logged twice. The API takes
// `^[A-Za-z0-9_-]{1,64}$` (backend/training/constants.py CLIENT_ID_RE).
export const CLIENT_ID_RE = /^[A-Za-z0-9_-]{1,64}$/;

const hex = (bytes) =>
  Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

/**
 * A fresh id for one set, minted once when the person taps Log and reused
 * on every retry. `crypto.randomUUID` exists only in secure contexts, so a
 * phone testing over http://<LAN-ip>:5173 gets the fallback: the time plus
 * random bytes (`getRandomValues` works on plain http), or Math.random
 * where even that is missing. Unique enough per session either way — the
 * server only compares ids within one session.
 */
export function newClientId() {
  const c = globalThis.crypto;
  if (typeof c?.randomUUID === "function") return c.randomUUID();
  let random;
  if (typeof c?.getRandomValues === "function") {
    random = hex(c.getRandomValues(new Uint8Array(12)));
  } else {
    random = `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  }
  return `${Date.now().toString(36)}-${random}`.slice(0, 64);
}
